import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { CustomDatePipe } from '@app-core/pipes/custom-date.pipe';
import { TimeDistancePipe } from '@app-core/pipes/time-distance.pipe';
import { ProductStatusStringComponent } from 'src/app/entities/products/components/product-status-string/product-status-string.component';
import { ProductStatusIconComponent } from 'src/app/entities/products/components/product-status-icon/product-status-icon.component';

import { INotification } from '../../state/notification.model';

@Component({
  standalone: true,
  selector: 'sandoz-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,

    CustomDatePipe,
    TimeDistancePipe,
    ProductStatusIconComponent,
    ProductStatusStringComponent,

    MatIconModule,
    MatTooltipModule,
  ],
})
export class NotificationItemComponent {
  private _notification!: INotification;
  @Input({ required: true })
  set notification(v: INotification) {
    this._notification = v;
  }
  get notification(): INotification {
    return this._notification;
  }
}
